import mapboxgl from "mapbox-gl";
import config from "config";

const startMap = (lat, lng, { current }) => {
  mapboxgl.accessToken = config.token;
  const map = new mapboxgl.Map({
    container: current, // container id
    style: "mapbox://styles/mapbox/outdoors-v11",
    zoom: 9.2, // starting zoom
    logoPosition: "top-left",
    attributionControl: false,
  });
  return map;
};

export default startMap;
